import React from 'react';
import { useQuery } from '@apollo/client';
import { Row } from 'antd';
import { Table, Select } from '..';
import Wrapper from './style';
import PricingItem from './pricingItem';
import { sortingCompareLicense } from './licenseFeaturesUtils';
import columns from './columns.license';
import { GET_LICENSE_BY_ID } from '../../graphql/queries';
import licenseConfigs from './license.config';
import { renewalType, licenseID } from '../../configs/license';

const { Option } = Select;

const Index = ({ onChooseLicense, setSelectedPricing, selectedPricing }) => {
  const { data: personalLicense } = useQuery(GET_LICENSE_BY_ID, {
    variables: {
      id: licenseID.personal.id,
    },
  });
  const { data: businessLicense } = useQuery(GET_LICENSE_BY_ID, {
    variables: {
      id: licenseID.business.id,
    },
  });
  const { data: enterpriseLicense } = useQuery(GET_LICENSE_BY_ID, {
    variables: {
      id: licenseID.enterprise.id,
    },
  });

  const parsedLicenseListConfig = [
    {
      max_socmed_account: personalLicense?.list?.max_socmed_account,
      max_team_member: personalLicense?.list?.max_team_member,
      name: personalLicense?.list?.name,
    },
    {
      max_socmed_account: businessLicense?.list?.max_socmed_account,
      max_team_member: businessLicense?.list?.max_team_member,
      name: businessLicense?.list?.name,
    },
    {
      max_socmed_account: enterpriseLicense?.list?.max_socmed_account,
      max_team_member: enterpriseLicense?.list?.max_team_member,
      name: enterpriseLicense?.list?.name,
    },
  ];

  const onChangePricing = (value) => {
    setSelectedPricing(value);
  };
  return (
    <Wrapper>
      <div className="component_features_header">
        <Row gutter={[24, 24]}>
          <div className="font-subtitle1 component_features_header-title">
            Available Licenses
          </div>
          <Select
            className="component_features_header_options"
            value={selectedPricing}
            onChange={onChangePricing}
          >
            {renewalType.map((item) => {
              return <Option value={item?.value}>{item?.label}</Option>;
            })}
          </Select>
        </Row>
      </div>
      <div className="component_features_pricing">
        <div className="component_features_pricing_list">
          {personalLicense?.list && (
            <PricingItem
              dataSource={personalLicense?.list}
              licenseConfig={licenseID.personal}
              selectedMenu={selectedPricing}
              onChooseLicense={onChooseLicense}
            />
          )}
          {businessLicense?.list && (
            <PricingItem
              dataSource={businessLicense?.list}
              licenseConfig={licenseID.business}
              selectedMenu={selectedPricing}
              onChooseLicense={onChooseLicense}
            />
          )}
          {enterpriseLicense?.list && (
            <PricingItem
              dataSource={enterpriseLicense?.list}
              licenseConfig={licenseID.enterprise}
              selectedMenu={selectedPricing}
              onChooseLicense={onChooseLicense}
            />
          )}
        </div>
      </div>
      <div className="component_features_compare">
        <div className="component_features_compare_header">
          <div className="font-header2_medium component_features_header_title">
            Compare Licenses
          </div>
          <div className="font-subtitle1 component_features_header_subtitle">
            Quickly compare the differences between each licenses
          </div>
        </div>
        <div className="component_features_compare_body">
          <Table
            dataSource={sortingCompareLicense}
            columns={columns(
              licenseConfigs({
                configs: parsedLicenseListConfig,
              })
            )}
            pagination={false}
            showHeader={false}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default Index;
